import axios from 'axios'

export default {
  // 推送h5消息
  pushH5Msg: function (platformId) {
    let apiUrl = global.API_HOST + 'qqread/message/returnPlayerMsg?platformId=' + platformId

    axios.get(apiUrl).then(function (response) {
      if (response.data.code !== 0) {
        console.log(response.data.msg)
      }
    }).catch(function (error) {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/v2/static/js/commonMethods.js